import { PhaseType } from "@/redux/slices/timerConfigurationSlice"

export const PHASE_TYPES = {
  RANDR: 'randr',
  ADVISOR: 'advisor',
  NEGOTIATION: 'negotiation',
  DECISION: 'decision',
} as const satisfies Record<string, PhaseType>

export const PHASE_LABELS: Record<PhaseType, string> = {
  [PHASE_TYPES.RANDR]: 'Orientation & Context',
  [PHASE_TYPES.ADVISOR]: 'Strategic Preparation',
  [PHASE_TYPES.NEGOTIATION]: 'Diplomacy & Influence',
  [PHASE_TYPES.DECISION]: 'Execution & Adjudication',
}
  
export const NAVY = '#1a2b4b'
export const CARD_BG = '#f0f2f5'
export const FIVE_MIN_SECONDS = 5 * 60
export const ONE_MIN_SECONDS = 60